import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'lockvue-user-integration',
  templateUrl: './user-integration.component.html',
  styleUrls: ['./user-integration.component.scss'],
})
export class UserIntegrationComponent {
  @Input() value;

  constructor() {}
}
